<template>

  <div class="grid-content bg-purple ">
    <h2 style="float: left">指标类别列表</h2>
    <el-button type="primary" @click="dialogscoreTypeAdd=true">添加指标类别</el-button>
    <div class="table-box" >

      <el-table
        :data="scoreTyperList.list"
        height="550"
        border
        style="width: 100%;">
        <el-table-column
          prop="id"
          label="序号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="scoreTypeName"
          label="指标类别"
          width="180">
        </el-table-column>
        <el-table-column

          prop="sort"
          label="排序">

        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
            	type="success"
              size="mini"
              @click="openscoreType(scope.row.id)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="openDelete(scope.row.id)">删除</el-button>

          </template>
        </el-table-column>

      </el-table>
      <el-pagination
      	v-if="scoreTyperList.scoreTyperListtotal>10"
        background
        layout="prev, pager, next"
        :page-size="scoreTyperList.scoreTyperListtpageSize"
        @current-change="setscoreTypeSelectlist"
        :total="scoreTyperList.scoreTyperListtotal">

      </el-pagination>
    </div>


  <!--企业修改-->

  <el-dialog  :visible.sync="dialogscoreTypeAdd" :before-close="dialogrolVscoreTypeclose">
    <el-form ref="form"  label-width="150px">

      <el-form-item label="指标类别">
        <el-input v-model="scoreTypeAdds.scoreTypeName" type="text" placeholder="请输入指标类别："></el-input>
      </el-form-item>


      <el-form-item label="排序">
        <el-input v-model="scoreTypeAdds.sort" type="number"  min = '0' placeholder="请输入排序："></el-input>
        <span style="float: left; color: #DCDFE6;">数字越小越靠前</span>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="scoreTypeAdd()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>


  <el-dialog  :visible.sync="dialogupdatTypeid" :before-close="dialogrolVscoreTypeclose">
    <el-form ref="form"  label-width="150px">

      <el-form-item label="指标类别">
        <el-input v-model="updatscoreTypeBy.scoreTypeName" type="text" placeholder="请输入指标类别："></el-input>
      </el-form-item>


      <el-form-item label="排序">
        <el-input v-model="updatscoreTypeBy.sort" type="number" min = '0' placeholder="请输入排序："></el-input>
        <span style="float: left; color: #DCDFE6;">数字越小越靠前</span>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="scoreTypeUp()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Scoretype",
  data(){
    return {
//指标项分类
      scoreTyperList:{
        list:[],
        scoreTyperListtpage:1,
        scoreTyperListtotal:0,
        scoreTyperListtpageSize:10
      },
      //新增指标项分类
      scoreTypeAdds:{
        scoreTypeName:'',
        sort:'',
      },
      dialogscoreTypeAdd:false,

      scoreTypeid:'',
      updatscoreTypeBy:{
        scoreTypeName:'',
        sort:'',

      },
      dialogupdatTypeid:false,

    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.scoreTypeSelectlist();
  },
  methods: {
    dialogrolVscoreTypeclose(){
        this.dialogupdatTypeid=false;
        this.updatscoreTypeBy = {
          scoreTypeName:'',
          sort:'',

        };
      this.dialogscoreTypeAdd=false;
      this.scoreTypeAdds = {
        scoreTypeName:'',
        sort:'',
      };


    },
    //考核项分类列表
    scoreTypeSelectlist(){
      let that = this;
      let scoreTypedata = {
        page:this.scoreTyperList.scoreTyperListtpage,
        pageSize:this.scoreTyperList.scoreTyperListtpageSize
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/scoreType/scoreTypeSelect',scoreTypedata)
        .then(function (res) {

          if(res.data.code==200){
            that.scoreTyperList.list = res.data.data.list;
            that.scoreTyperList.scoreTyperListtotal = res.data.data.total;
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    setscoreTypeSelectlist(scoreTyperListtpage){
      this.scoreTyperList.scoreTyperListtpage = scoreTyperListtpage;
      this.scoreTypeSelectlist();
    },

    //新增考核项分类
    scoreTypeAdd(){
      let that = this;
      if (that.scoreTypeAdds.scoreTypeName == '') {
        that.$message.error('请输入指标类别名称');
        return false;
      }
      if (that.scoreTypeAdds.sort == '') {
        that.$message.error('请输入排序');
        return false;
      }
      if (that.scoreTypeAdds.sort < 0) {
        that.$message.error('排序为负数');
        return false;
      }
      let scoreTypeAddsa = {
        scoreTypeName:that.scoreTypeAdds.scoreTypeName,
        sort:that.scoreTypeAdds.sort
      }
      this.$axios
        .post('/api/scoreType/scoreTypeAdd', scoreTypeAddsa)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增指标类别失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增指标类别成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },





//编辑考核项分类


    selectscoreTypeById(){

      let that = this;

      let updatescoreTypeByIddata = {
        id:that.scoreTypeid
      }
      this.$axios
        .post('/api/scoreType/scoreTypeById', updatescoreTypeByIddata)
        .then(function (res) {

          that.updatscoreTypeBy.scoreTypeName=res.data.data.scoreTypeName;
          that.updatscoreTypeBy.sort=res.data.data.sort;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    openscoreType(scoreTypeid){

      this.scoreTypeid = scoreTypeid;

      this.selectscoreTypeById();
      window.setTimeout(() => {
        this.dialogupdatTypeid = true;
      },100);


    },
//修改企业信息
    scoreTypeUp(){
      let that = this;
      if (that.updatscoreTypeBy.scoreTypeName == '') {
        that.$message.error('请输入指标类别名称');
        return false;
      }
      if (that.updatscoreTypeBy.sort == '') {
        that.$message.error('请输入排序');
        return false;
      }
      if (that.updatscoreTypeBy.sort < 0) {
        that.$message.error('排序为负数');
        return false;
      }
      let scoreTypeUpdates = {
        id:that.scoreTypeid,
        scoreTypeName:that.updatscoreTypeBy.scoreTypeName,
        sort:that.updatscoreTypeBy.sort,
      }
      this.$axios
        .post('/api/scoreType/scoreTypeUpdate', scoreTypeUpdates)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改指标类别失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改指标类别成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


    openDelete(scoreTypeId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletescoreType(scoreTypeId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

//删除考核项分类
    deletescoreType(scoreTypeId){
      let that = this;
      let scoreTypeIdsa = {
        scoreTypeIds:[]
      }
      scoreTypeIdsa.scoreTypeIds.push(scoreTypeId);
      this.$axios
        .post('/api/scoreType/scoreTypeBatchDelete',scoreTypeIdsa)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },




  },
  watch: {

  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/admin/Scoretype.vue